import { TimerRemoveIcon } from './TimerRemoveIcon';

/**
 * author: Colton Wiscombe
 * id 558B0DE6-0A7D-4BC6-ACAD-EB52A8B58A86
 * name timer-remove
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-remove.svg
 * tags
 * - Date / Time 
 */
export const StopwatchRemoveIcon = TimerRemoveIcon;
export default StopwatchRemoveIcon